<template>
    <v-app id="inspire">
        <v-layout :class="{ 'pos-layout--with-announcement': !announcementDismissed }">

            <!-- Announcement Banner -->
            <AnnouncementBanner v-if="!announcementDismissed" @close="announcementDismissed = true" />
            
            <!-- Header -->
            <AppBar />

            <!-- Left menu -->
            <NavigationDrawer v-model="appStore.ShowNavDrawer.ShowDrawerLeft" />
            
            <!-- Main -->
            <v-main>
                <div v-show="!appStore.ShowLoaderMain">
                    <slot></slot>
                </div>

                <div v-show="appStore.ShowLoaderMain" class="loader loader-main" />
            </v-main>

            <!-- <NavigationDrawerRight /> -->

            <!-- <Modal title="Sprememba gesla" :display="appStore.User.NeedsToChangePassword" acceptText="Shrani geslo" closeText="Prekliči" @accept="SavePassword()" @modalClosed="DeclinePasswordChange()" class="">
                <div class="mb-2">
                    <label class="form-label">Novo geslo</label>
                    <v-text-field 
                        v-model="v$.NewPassword.$model"
                        :error-messages="v$.NewPassword.$errors[0] != null ? v$.NewPassword.$errors[0].$message : ''"
                        @focus="v$.NewPassword.$reset"                                        
                        variant="outlined"
                        type="password"
                    >
                    </v-text-field>
                </div>
                <div class="">
                    <label class="form-label">Ponovite geslo</label>
                    <v-text-field 
                        v-model="v$.RepeatPassword.$model"
                        :error-messages="v$.RepeatPassword.$errors[0] != null ? v$.RepeatPassword.$errors[0].$message : ''"
                        @focus="v$.RepeatPassword.$reset"                                     
                        variant="outlined"
                        type="password"
                    >
                    </v-text-field>
                </div>

            </Modal> -->

            <Modal :display="appStore.AppNotifications.ShownNotification != undefined"
                :title="appStore.AppNotifications.ShownNotification != undefined ? appStore.AppNotifications.ShownNotification.Title : ''"
                :showAcceptButton="appStore.AppNotifications.ShownNotificationIndex < appStore.FilterNotifications.length - 1"
                :showDeclineButton="true" closeText="Zapri" acceptText="Naslednje obvestilo"
                @accept="appStore.ShowNotification(appStore.AppNotifications.ShownNotificationIndex + 1)"
                @modalClosed="appStore.AppNotifications.ShownNotification = undefined" class="dialog-notification-xl">
                <div v-if="appStore.AppNotifications.ShownNotification != undefined"
                    v-html="appStore.AppNotifications.ShownNotification.Text"></div>
            </Modal>

            <Modal :display="appStore.OpenChangePassModal" :showCloseXButton="false" title="Sprememba gesla"
                :showAcceptButton="true" :showDeclineButton="false" acceptText="Spremeni geslo"
                @accept="ToPasswordChange()" :btnCenter="true">
                <div>
                    <div>
                        <p>Za zagotavljanje večje varnosti spremenite svoje geslo.</p>
                    </div>

                </div>
            </Modal>
            
        </v-layout>
    </v-app>

    <v-snackbar v-model="appStore.Snackbar.ShowSnackBar" :timeout="4000" color="#ECF8E6" location="top"
        :class="appStore.Snackbar.Class">
        <template v-slot:text>
            <div class="d-flex align-center ga-2">
                <img :src="appStore.Snackbar.Image" alt="Icon" class="icon-pre-text">
                <span>{{ appStore.Snackbar.SnackbarText }}</span>
            </div>
        </template>
        <template v-slot:actions>
            <v-btn icon @click="appStore.Snackbar.ShowSnackBar = false" size="small">
                <img src="@assets/images/general/icon-close-success.svg" alt="Close" class="icon-snack-close">
            </v-btn>
        </template>
    </v-snackbar>

</template>

<script setup lang="ts">
    import AnnouncementBanner from "@components/layout/announcement-banner.vue";
    import AppBar from "@components/layout/app-bar.vue";
    import NavigationDrawer from "@components/layout/navigation-drawer.vue";
    import { useAppStore } from "@appstore/store";
    import Modal from "@/app/components/modal.vue";
    import router from "@/app/router";
    import { ref } from "vue";

    let appStore = useAppStore();
    const announcementDismissed = ref(false);

    function ToPasswordChange() {
        router.push({ name: 'profil_home' })
    }

    // async function SavePassword() {
    //     await validateForm().then(() => {
    //         v$.value.$reset();
    //         appStore.savePassword();
    //     });
    // }

    // function DeclinePasswordChange() {
    //     appStore.cancelSavePassword();
    // }

    // // Vuelidate
    // async function validateForm(): Promise<void>{
    //     v$.value.$touch();
    //     let formValid = await v$.value.$validate();
    //     return new Promise((resolve) => {
    //         if(formValid){
    //             resolve();
    //         }
    //     });
    // };

    // const validationRules = computed(() => ({
    //     NewPassword: {
    //         required: errors.fieldRequired,
    //         complexPassword: helpers.withMessage("Geslo mora biti dolgo vsaj 8 znakov in vsebovati vsaj eno veliko črko, malo črko, številko in poseben znak", () => /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W\_])[A-Za-z\d\W\_]{8,}$/.test(appStore.PasswordChange.NewPassword))
    //     },
    //     RepeatPassword: {
    //         required: errors.fieldRequired,
    //         matches: helpers.withMessage("Gesli se ne ujemata", () => appStore.PasswordChange.NewPassword == appStore.PasswordChange.RepeatPassword)
    //     }
    // }))

    // const v$: any = useVuelidate(validationRules, computed(() => appStore.PasswordChange));

</script>
